import React, {Component} from 'react';
import courseCode from "../js/coursecode";
import Dropdown from "../components/Dropdown";
import Input from "../components/Input";
import CourseList from "../components/CourseList";
 import zipcelx from "zipcelx";
import itemFilter from "../components/itemFilter";
import csvLine from "../components/csvLine";
//import config from '../config.json';
const { jsPDF } = require('jspdf');
require('jspdf-autotable');

const yearFormatter = (year) => {
    return {
        value: year,
        label: year.substring(0, 4) + " - " + year.substring(4)
    }
}

const subjectFormatter = (subject) => {
    return {
        value: subject.code,
        label: subject.longLiteral + ' (' + subject.code + ')'
    }
}

class CourseListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            yearsLoaded: false,
            years: [],
            activeYear: false,
            subjects: {},
            courses: {},
            activeSubject: false,
            view: 'expanded',
            loading: true,
            namefilter: '',
            coursefilter: '',
            endorsementfilter: '',
            gradefilter: [],
            gradeDropdownOpen:false,
            downloadUrl: false
        };
        if (window.coursedataurl && window.coursedataurl !== '') {
            courseCode.dataUrl = window.coursedataurl;
        }

        if (window.courseapitoken && window.courseapitoken !== '') {
            courseCode.apiToken = window.courseapitoken;
        }

        if (window.courseapiclient && window.courseapiclient !== '') {
            courseCode.apiClient = window.courseapiclient;
        } else {
            courseCode.apiClient = "CourseCodeClient";
        }

        this.handleSubjectSelect = this.handleSubjectSelect.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);
        this.handleViewChange = this.handleViewChange.bind(this);
        this.handleFilterKeyup = this.handleFilterKeyup.bind(this);
        this.handleDownloadClick = this.handleDownloadClick.bind(this);
        this.handleDownloadPDFClick = this.handleDownloadPDFClick.bind(this);
        this._loadSubject = this._loadSubject.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.clearFilter = this.clearFilter.bind(this);

    }

    componentWillUnmount() { document.removeEventListener("click", this.handleClickOutside); }
    
    componentDidMount() {
        let app = this;
        document.addEventListener("click", this.handleClickOutside);
        if (!this.state.yearsLoaded) {
            courseCode.getDataYears(function (years) {
                let activeYear = false;
                if (years && years.length) activeYear = years[0];
                courseCode.getSubjects(activeYear, 1, 1000, function (subjects) {
                    let oldSubjects = app.state.subjects;
                    oldSubjects[activeYear] = subjects;
                    app.setState({
                        yearsLoaded: true,
                        years: years,
                        activeYear: activeYear,
                        subjects: oldSubjects,
                        loading: false
                    });
                });
            });
        }
    }

    componentDidUpdate() {
        //console.log('updating')
        if (this.state.downloadUrl) {
            var app = this;
            setTimeout(function () {
                app.setState({
                    downloadUrl: false
                })
            }, 5000);
        }
    }

    handleSubjectSelect(evt) {
        let subject = evt.target.value;
        if (subject === "") return;
        let activeYear = this.state.activeYear;
        let app = this;
        app.setState({
            loading: true,
        });

        // show loading for a 3/4 of a second as a visual cue
        setTimeout(function(){
            app._loadSubject(subject, activeYear)
        }, 750)



    }
    _loadSubject( subject, activeYear ) {
        let app = this;
        if (subject === "all" ||
            subject === "all-meet" ||
            subject === "all-nomeet") {
            let neededSubjects = [];
            switch (subject) {
                case "all":
                    for (let x in this.state.subjects[activeYear]) {
                        let subjectCode = this.state.subjects[activeYear][x].code;
                        if (!this.state.courses[activeYear] || !this.state.courses[activeYear][subjectCode]) neededSubjects.push(subjectCode)
                    }
                    break;
                case "all-meet":
                    for (let x in this.state.subjects[activeYear]) {
                        if (this.state.subjects[activeYear][x].iuRequired === "Y") {
                            let subjectCode = this.state.subjects[activeYear][x].code;
                            if (!this.state.courses[activeYear] || !this.state.courses[activeYear][subjectCode]) neededSubjects.push(subjectCode)
                        }
                    }
                    break;
                case "all-nomeet":
                    for (let x in this.state.subjects[activeYear]) {
                        if (this.state.subjects[activeYear][x].iuRequired === "N") {
                            let subjectCode = this.state.subjects[activeYear][x].code;
                            if (!this.state.courses[activeYear] || !this.state.courses[activeYear][subjectCode]) neededSubjects.push(subjectCode)
                        }
                    }
                    break;
                default:
            }
            if (neededSubjects.length > 0) {
                courseCode.getCoursesBySubjectCollection(activeYear, neededSubjects, 1, 1000, function (courses) {
                    let oldCourses = app.state.courses;
                    if (!oldCourses[activeYear]) oldCourses[activeYear] = {};
                    for (let x in neededSubjects) {
                        oldCourses[activeYear][neededSubjects[x]] = courses[neededSubjects[x]].courses;
                    }
                    app.setState({
                        activeSubject: subject,
                        courses: oldCourses,
                        loading: false
                    });
                });
            } else {
                app.setState({
                    activeSubject: subject,
                    loading: false
                });
            }
        } else if (this.state.courses[activeYear] && this.state.courses[activeYear][subject]) {
            app.setState({activeSubject: subject, loading: false})
        } else {
            courseCode.getCoursesBySubject(activeYear, subject, 1, 1000, function (courses) {
                let oldCourses = app.state.courses;
                if (!oldCourses[activeYear]) oldCourses[activeYear] = {};
                oldCourses[activeYear][subject] = courses;
                app.setState({
                    activeSubject: subject,
                    courses: oldCourses,
                    loading: false
                });
            });
        }
    }

    handleYearChange(evt) {
        this.setState({loading: true});
        let newyear = evt.target.value;
        let activeSubject = this.state.activeSubject

        let needLoad = false;
        if ( ! this.state.subjects[newyear] ) needLoad = true;
        if ( !needLoad && activeSubject!=='' && !this.state.subjects[newyear][activeSubject] ) needLoad = true;
        //console.log( 'needLoad:', needLoad)
        if ( !needLoad  ) {
            this.setState({
                activeYear: newyear,
                loading: false
            })
        } else {
            let app = this;

            //console.log('getting subjects for', newyear);
            courseCode.getSubjects(newyear, 1, 1000, function (subjects) {
                let oldSubjects = app.state.subjects;
                oldSubjects[newyear] = subjects;

                //console.log('activeSubject:', app.state.activeSubject)
                if (app.state.activeSubject) {
                    courseCode.getCoursesBySubject(newyear, app.state.activeSubject, 1, 1000, function (courses) {
                        let oldCourses = app.state.courses;
                        if (!oldCourses[newyear]) oldCourses[newyear] = {};
                        oldCourses[newyear][app.state.activeSubject] = courses;

                        app.setState({
                            subjects: oldSubjects,
                            activeYear: newyear,
                            courses: oldCourses,
                            loading: false
                        });
                        if ( app.state.coursefilter || app.state.namefilter || app.state.endorsementfilter || app.state.gradefilter.length>0) {
                            app.handleSubjectSelect({target: {value: 'all'}})
                        }
                        app.handleSubjectSelect({target: {value: app.state.activeSubject }})
                    });
                } else {
                   // console.log('c filter', app.state.coursefilter)
                    app.setState({
                        activeYear: newyear,
                        subjects: oldSubjects,
                        loading: false
                    });

                    if ( app.state.coursefilter || app.state.namefilter || app.state.endorsementfilter || app.state.gradefilter.length>0) {
                        app.handleSubjectSelect({target: {value: 'all'}})
                    }

                }

            });
        }
    }

    handleViewChange(evt) {
        if (evt.target.getAttribute('href') === "#expanded") {
            this.setState({view: 'expanded'})
        }
        if (evt.target.getAttribute('href') === "#compact") {
            this.setState({view: 'compact'})
        }
    }

    handleClickOutside = (e) => {
  // If dropdown is closed, do nothing
  if (!this.state.gradeDropdownOpen) return;

  // If click is inside the dropdown, do nothing
  if (this.dropdownRef && this.dropdownRef.contains(e.target)) {
    return;
  }

  // Otherwise close it
  this.setState({ gradeDropdownOpen: false });
};

    handleFilterKeyup(evt) {

        if (this.filterTimeout) clearTimeout(this.filterTimeout);

        let id = evt.target.name;
        let app = this;

        app.setState({
            [id]: evt.target.value,
            activeSubject: 'all'
        })

        this.filterTimeout = setTimeout(function () {
            app.handleSubjectSelect({target: {value: 'all'}})
        }, 750);

    }

    applyFilter(evt) {
        evt.preventDefault();
    }

    clearFilter() {
        this.setState({
            namefilter: '',
            coursefilter: '',
            endorsementfilter: '',
            gradefilter:[]
        })
    }

    handleDownloadClick() {

        //const filteredCourses = this.state.courses[ item.code ].filter(item=>itemFilter(item, props) );
        let thisYearCourses = this.state.courses[this.state.activeYear];
        if (!thisYearCourses || !Object.keys(thisYearCourses).length) {
            return;
        }

        let base_filename = "NDE_CourseCodes_" + this.state.activeYear + "_";
        let subject = this.state.activeSubject;
        let subjects = this.state.subjects[this.state.activeYear];
        let filteredCourses = [];
        let filter = {
            namefilter: this.state.namefilter,
            coursefilter: this.state.coursefilter,
            endorsementfilter: this.state.endorsementfilter,
            gradefilter:this.state.gradefilter
        };


        if (subject === "all" || subject === "all-meet" || subject === "all-nomeet") {
            base_filename += subject;
            //filter down subjects
            subjects.filter(subject => {
                if (subject === "all") return true;
                if (subject === "all-meet") return subject.iuRequired === "Y";
                if (subject === "all-nomeet") return subject.iuRequired === "N";
                return false;
            });
            //filter down courses within each subject
            let subjectFilteredCourses = subjects.map((item, i) => {
                const filteredCoursesForSubject = thisYearCourses[item.code].filter(item => itemFilter(item, filter));
                for (let x in filteredCoursesForSubject) {
                    filteredCoursesForSubject[x].subjectName = item.longLiteral
                }

                return filteredCoursesForSubject
            })

            for (let subjectCourses in subjectFilteredCourses) {
                for (let x in subjectFilteredCourses[subjectCourses]) {
                    filteredCourses.push(subjectFilteredCourses[subjectCourses][x]);
                }

            }
        } else {
            filteredCourses = thisYearCourses[subject].filter(item => itemFilter(item, filter));
            let MySubjectName = subjects.filter(item => item.code === subject)[0].longLiteral
            for (let x in filteredCourses) {
                filteredCourses[x].subjectName = MySubjectName;
            }
            base_filename += MySubjectName.replace(/,/g, '').replace(/ /g, '_').replace('/', '-');
        }
        let header = ['code', 'short name', 'name'];
        if (this.state.view === 'expanded') {
            header = ['code', 'short name', 'name', 'description', 'subject', 'endorsement codes'];
        }
        let lines = filteredCourses.map(function (course) {
            return csvLine(course, this.state.view);
        }, this);

        header = [header.map(h => {
            return {value: h, type: 'string'}
        })];


        const config = {
            filename: base_filename,
            sheet: {
                data: header.concat(lines)
            }
        }

        zipcelx(config);
        //var blob = new Blob( lines, {type: "text/csv;charset=utf-8"});
        //saveAs(blob, base_filename + ".txt");
    }


handleDownloadPDFClick() {
//    const doc = new jsPDF();
//     const thisYearCourses = this.state.courses[this.state.activeYear];
//     if (!thisYearCourses || !Object.keys(thisYearCourses).length) {
//         return;
//     }

//     let base_filename = "NDE_CourseCodes_" + this.state.activeYear + "_";
//     const subject = this.state.activeSubject;
//     const subjects = this.state.subjects[this.state.activeYear];
//     let filteredCourses = [];
//     const filter = {
//         namefilter: this.state.namefilter,
//         coursefilter: this.state.coursefilter,
//         endorsementfilter: this.state.endorsementfilter,
//         gradefilter:this.state.gradefilter
//     };

//     if (subject === "all" || subject === "all-meet" || subject === "all-nomeet") {
//         base_filename += subject;

//         // const filteredSubjects = subjects.filter(subject => {
//         //     if (subject === "all") return true;
//         //     if (subject === "all-meet") return subject.iuRequired === "Y";
//         //     if (subject === "all-nomeet") return subject.iuRequired === "N";
//         //     return false;
//         // });
//         const filteredSubjects = subjects.filter(item => {
//     if (subject === "all") return true;
//     if (subject === "all-meet") return item.iuRequired === "Y";
//     if (subject === "all-nomeet") return item.iuRequired === "N";
//     return false;
// });


//         const subjectFilteredCourses = filteredSubjects.map(item => {
//             const filteredCoursesForSubject = thisYearCourses[item.code].filter(item => itemFilter(item, filter));
//             filteredCoursesForSubject.forEach(course => {
//                 course.subjectName = item.longLiteral;
//             });
//             return filteredCoursesForSubject;
//         });

//         subjectFilteredCourses.forEach(subjectCourses => {
//             filteredCourses.push(...subjectCourses);
//         });

//     } else {
//         filteredCourses = thisYearCourses[subject].filter(item => itemFilter(item, filter));
//         const MySubjectName = subjects.find(item => item.code === subject).longLiteral;
//         filteredCourses.forEach(course => {
//             course.subjectName = MySubjectName;
//         });
//         base_filename += MySubjectName.replace(/,/g, '').replace(/ /g, '_').replace('/', '-');
//     }

//     // Define headers
//     let header = ['Code', 'Short Name', 'Name'];
//     if (this.state.view === 'expanded') {
//         header = ['Code', 'Short Name', 'Name', 'Description', 'Subject', 'Endorsement Codes'];
//     }

//     // Prepare data rows using csvLine
//     // const lines = filteredCourses.map(course => csvLine(course, this.state.view));
//     const lines = filteredCourses.map(course => {
//   const row = csvLine(course, this.state.view);

//   if (this.state.view === 'expanded' && typeof row[5] === 'string') {
//     // Convert comma-separated string to multi-line string
//     row[5] = row[5].split(',').map(code => code.trim()).join('\n');
//   }

//   return row;
// });





//     // // Excel export
//     // const excelHeader = [header.map(h => ({ value: h, type: 'string' }))];
//     // const excelLines = lines.map(row =>
//     //     row.map(cell => ({ value: cell, type: 'string' }))
//     // );

//     // zipcelx({
//     //     filename: base_filename,
//     //     sheet: {
//     //         data: excelHeader.concat(excelLines)
//     //     }
//     // });

//     // PDF export using autoTable
//     const pdfRows = lines.map(row =>
//         row.map(cell => (typeof cell === 'object' && cell.value !== undefined) ? String(cell.value) : String(cell))
//     );

//     doc.setFontSize(14);
//     doc.text("Listed Courses", 14, 20);




// doc.autoTable({
//   startY: 30,
//   head: [header],
//   body: pdfRows,
//   styles: {
//     fontSize: 9,
//     overflow: 'linebreak',
//     cellPadding: 2
//   },
//   headStyles: {
//     fillColor: [41, 128, 185],
//     textColor: 255
//   },
//   alternateRowStyles: {
//     fillColor: [245, 245, 245]
//   },
//   columnStyles: {
//     0: { cellWidth: 15 },         // code
//     1: { cellWidth: 20 },         // short name
//     2: { cellWidth: 25 },         // name
//     3: { cellWidth: 75 },     // description
//     4: { cellWidth: 25 }, 
//     5: { cellWidth: 25 }, 
//   },
//   margin: { left: 13, right: 12 }
// });


//     doc.save(base_filename + ".pdf");
const content = document.getElementById('printable-section').innerHTML;
  const printWindow = window.open('', '', 'height=600,width=800');
  printWindow.document.write('<html><head><title>Print Courses</title>');
//   printWindow.document.write('<style>body { font-family: Arial; padding: 20px; }</style>');
printWindow.document.write(`
  <style>
    @media print {
      body {
        font-family: Arial, sans-serif;
        font-size: 12pt;
        color: #000;
        padding: 20px;
      }

      .no-print {
        display: none !important;
      }

      .only-print {
        display: block !important;
      }

      .container.endorsements {
        margin-top: 20px;
      }

      .container.endorsements .endorsementdisclaimer {
        background-color: #333 !important;
        color: white !important;
        padding: 10px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
      }

      .container.endorsements .columns {
        display: table-row;
      }

      .container.endorsements .column {
        display: table-cell;
        padding: 8px;
        border: 1px solid #000;
        vertical-align: top;
      }

      .container.endorsements strong {
        font-weight: bold;
      }
    }
  </style>
`);


  printWindow.document.write('</head><body>');

  // Add year header
printWindow.document.write(`<div class="print-header">Course Listings for Year: ${this.state.activeYear}</div>`);

  printWindow.document.write(content);
  printWindow.document.write('</body></html>');
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
}


    render() {
        let printTitle = "";
        if (this.state.activeSubject !== "all" && this.state.subjects[this.state.activeYear]) {
            let subjectObject = this.state.subjects[this.state.activeYear].filter((item) => item.code === this.state.activeSubject)
            if (subjectObject.length) printTitle = subjectObject[0].longLiteral;

        }
        return (
            <div className="section courselistingpage">
                <h1 className="title is-1">Course Codes and Clearing Endorsements</h1>
                <iframe title="Data Download Iframe" className="is-hidden" style={{width: 0, height: 0}}
                        src={this.state.downloadUrl ? this.state.downloadUrl : undefined}></iframe>
                <header className="container header no-print">
                    <div className="columns">
                        <div className="column is-6">
                            <Dropdown data={this.state.subjects[this.state.activeYear]} label="Subject"
                                      formatter={subjectFormatter} preOptions={[
                                {value: "", label: "Select Subject..."},
                                {value: "", label: "----------------------"},
                                {value: "all", label: "All Subjects"},
                                {value: "all-meet", label: "Only subjects that meet 92NAC 10-004.04B"},
                                {value: "all-nomeet", label: "Only Subjects that DO NOT meet 92NAC 10-004.04B"},
                                {value: "", label: "----------------------"}
                            ]} onchange={this.handleSubjectSelect}
                                      value={this.activeSubject}/>
                        </div>

                        <div className="column is-3 has-text-centered">
                            <label className="label">List Format</label>
                            <div className="buttons">
                                <a className={"button is-medium is-" + (this.state.view === "expanded" ? 'info has-text-weight-bold' : 'light')}
                                   onClick={this.handleViewChange} href="#expanded">
                                    Expanded
                                </a>
                                <a className={"button is-medium is-" + (this.state.view !== "expanded" ? 'info has-text-weight-bold' : 'light')}
                                   onClick={this.handleViewChange} href="#compact">
                                    Compact
                                </a>
                            </div>
                        </div>
                        <div className="column is-3">
                            <Dropdown data={this.state.years} label="Year" formatter={yearFormatter}
                                      onchange={this.handleYearChange}/>
                        </div>
                    </div>
                    <form onSubmit={this.applyFilter}>
                        <div className="columns has-background-light">
                            <div className="column is-4">
                                <Input label="Name" id="namefilter" placeholder="Full or partial"
                                       onChangeFunc={this.handleFilterKeyup}
                                       inputvalue={this.state.namefilter}/>
                            </div>
                            <div className="column is-2">
                                <Input label="Course Code" placeholder="eg. 350001" id="coursefilter"
                                       onChangeFunc={this.handleFilterKeyup} inputvalue={this.state.coursefilter}/>
                            </div>
                            <div className="column is-2">
                                <Input label="Endorsement" placeholder="Code or Name" id="endorsementfilter"
                                       onChangeFunc={this.handleFilterKeyup} inputvalue={this.state.endorsementfilter}/>
                            </div>
                            <div className="column is-2">
    <div className="field">
  <label className="label">Grade</label>

  <div
    className={"dropdown is-fullwidth " + (this.state.gradeDropdownOpen ? "is-active" : "")}
    ref={(el) => (this.dropdownRef = el)}
  >
    <div className="dropdown-trigger">
      <button
        type="button"
        className="button is-fullwidth"
        onClick={() =>
          this.setState({ gradeDropdownOpen: !this.state.gradeDropdownOpen })
        }
      >
        <span>
          {this.state.gradefilter.length
            ? this.state.gradefilter.join(", ")
            : "Select Grades"}
        </span>
        <span className="icon is-small">
          <i className="fas fa-angle-down"></i>
        </span>
      </button>
    </div>

    <div className="dropdown-menu" style={{ width: "100%" }}>
      <div
        className="dropdown-content"
        style={{ maxHeight: "200px", overflowY: "auto" }}
      >
        {["PreK","K",1,2,3,4,5,6,7,8,9,10,11,12].map((g) => (
          <label key={g} className="dropdown-item" style={{ cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={this.state.gradefilter.includes(String(g))}
              onChange={() => {
                const selected = this.state.gradefilter.includes(String(g))
                  ? this.state.gradefilter.filter((x) => x !== String(g))
                  : [...this.state.gradefilter, String(g)];

                this.setState({ gradefilter: selected });
              }}
              style={{ marginRight: "8px" }}
            />
            {g}
          </label>
        ))}
      </div>
    </div>
  </div>
</div>

</div>


                            <div className="column is-2">
                                <label className="label is-invisible">Clear Filter</label>
                                <div className="field">
                                    <p className="control">
                                        <button type="button" className="button is-warning is-medium"
                                                onClick={this.clearFilter}>
                                            CLEAR
                                        </button>
                                    </p>
                                </div>
                            </div>

                            <div className="column is-2 has-background-white">
                                <label className="label is-invisible">Download Listed Files</label>
                                <div className="field">
                                    <p className="control">
                                        <button type="button" className="button is-success is-medium"
                                                title="Download Excel of Listed Courses"
                                                onClick={this.handleDownloadClick}>
                                            Download Excel
                                        </button>
                                    </p>
                                </div>
                                <div className="field">
                                    <p className="control">
                                        <button type="button" className="button is-success is-medium"
                                                title="Download PDF of Listed Courses"
                                                onClick={this.handleDownloadPDFClick}>
                                            Download PDF
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </form>
                </header>
                {printTitle !== "" ?
                    <div className="section only-print">
                        <h1 className="title is-1">{printTitle}</h1>
                    </div> : ""}
                {(this.state.activeSubject === "all-meet" || this.state.activeSubject === "all-nomeet") ?
                    <div className="columns message92NAC box has-text-weight-bold">
                        {this.state.activeSubject === "all-meet" ?
                            <div className="meets92NAC column">
                                These courses apply in meeting 92NAC 10-004.04B (high school instructional offerings)
                                and are included in the calculation of properly endorsed instructional units/FTEs in
                                accordance
                                with 92NAC 10.004.04A, 10-007.02A, 10-007.03A and 92NAC 14-005.02A, 14-006-02A and
                                14-007-02A.
                            </div>
                            : ""}
                        {this.state.activeSubject === "all-nomeet" ?
                            <div className="notmeets92NAC column">
                                The following courses <em>DO NOT</em> apply in meeting 92NAC 10-004.04B (high school
                                instructional offerings). WIth the exception of Special Education,
                                these courses are included in the calculation of properly endorsed instructional
                                units/FTEs in accordance
                                with 92NAC 10.004.04A, 10-007.02A, 10-007.03A and 92NAC 14-005.02A, 14-006-02A and
                                14-007-02A.
                            </div>
                            : ""}
                    </div>
                    : ""}
                <div className="section courselisting" id="printable-section">
                    <div className={"container courses " + this.state.view}>
                        {this.state.courses && this.state.courses[this.state.activeYear] ?
                            <CourseList
                                courses={this.state.courses[this.state.activeYear]}
                                subject={this.state.activeSubject}
                                subjects={this.state.activeSubject === "all" || this.state.activeSubject === "all-meet" || this.state.activeSubject === "all-nomeet" ?
                                    this.state.subjects[this.state.activeYear].filter(subject => {
                                        if (this.state.activeSubject === "all") return true;
                                        if (this.state.activeSubject === "all-meet") return subject.iuRequired === "Y";
                                        if (this.state.activeSubject === "all-nomeet") return subject.iuRequired === "N";
                                        return false;
                                    }, this) :
                                    ""}
                                view={this.state.view}
                                namefilter={this.state.namefilter}
                                coursefilter={this.state.coursefilter}
                                endorsementfilter={this.state.endorsementfilter}
                                gradefilter={this.state.gradefilter}
                                datayear={this.state.activeYear}
                            />
                            :
                            <div className="has-text-centered notification is-info">No Courses Found</div>
                        }
                </div>
                </div>
                <div className={"modal " + (this.state.loading === true ? "is-active" : "")}>
                    <div className="modal-background"></div>
                    <div className="modal-content is-clipped">
                        <div className="level">
                            <div className="level-item">
                                <div className="is-size-2 has-text-white">
                                    <span className="">Loading...</span>
                                    <div className="progressholder">
                                        <progress className="progress is-medium is-primary" max="100">45%</progress>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CourseListPage;
